<template>
  <div class="flex grow flex-col overflow-y-auto px-3 py-4">
    <slot />
  </div>
</template>
